(function () {
  "use strict";

  const TEMPLATE = Object.freeze({
    id: "flessenpost-wide-v4",
    physical: Object.freeze({
      widthMm: 73,
      heightMm: 128,
      frontPixels: Object.freeze({ width: 859, height: 1505 }),
      backPixels: Object.freeze({ width: 740, height: 1287 }),
    }),
    rules: Object.freeze({
      front: Object.freeze({ maxChars: 36, maxWidthPx: 580, font: '700 32px "Courier New"' }),
      back: Object.freeze({ maxChars: 300, maxLines: 8, maxWidthPx: 620, font: '600 24px Georgia' }),
      sender: Object.freeze({ maxChars: 34, maxWidthPx: 440, font: '700 24px "Courier New"' }),
    }),
  });

  const SAMPLE = Object.freeze({
    front: ["OP JOUW NIEUWE AVONTUUR", "PROOST, JEROEN & TEAM"],
    back: [
      "Een bijzondere fles voor een bijzonder moment.",
      "Om samen open te maken en verhalen te delen.",
      "Voor alles wat achter ons ligt,",
      "en voor alles wat nog komen gaat.",
      "",
      "Met dank voor de mooie samenwerking.",
      "Bewaar de fles, maar vooral het verhaal.",
      "",
    ],
    sender: "JEROEN & TEAM",
  });

  const MOCKUP_ORIGIN = "Whisky Warehouse Mystery Malt";

  function bottledToday() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    return `Bottled: ${day}-${month}-${today.getFullYear()}`;
  }

  const canvas = document.createElement("canvas");
  const canvasContext = canvas.getContext("2d");
  let allowedCharacters;

  try {
    allowedCharacters = new RegExp(
      "^[\\p{L}\\p{N}\\p{M}\\p{Zs}.,'’\"“”!?&+\\-–—:/()@#%€$]*$",
      "u",
    );
  } catch (_error) {
    allowedCharacters = /^[A-Za-zÀ-ž0-9 .,'’"!?&+\-–—:/()@#%€$]*$/;
  }

  function asText(value) {
    if (value === null || typeof value === "undefined") return "";
    return String(value);
  }

  function normalizedForPrint(value) {
    return asText(value).toLocaleUpperCase("nl-NL");
  }

  function measuredWidth(value, font, uppercase = true) {
    if (!canvasContext) return 0;
    canvasContext.font = font;
    const printableValue = uppercase ? normalizedForPrint(value) : asText(value);
    return canvasContext.measureText(printableValue).width;
  }

  function splitBackToken(token, rule) {
    const pieces = [];
    let piece = "";

    Array.from(token).forEach((character) => {
      const candidate = `${piece}${character}`;
      if (piece && measuredWidth(candidate, rule.font, false) > rule.maxWidthPx) {
        pieces.push(piece);
        piece = character;
      } else {
        piece = candidate;
      }
    });

    if (piece) pieces.push(piece);
    return pieces;
  }

  function wrapBackText(value) {
    const rule = TEMPLATE.rules.back;
    const normalized = asText(value).replace(/\r\n?/g, "\n").trim();
    if (!normalized) return { lines: [], overflow: false, totalLines: 0 };

    const lines = [];
    normalized.split("\n").forEach((paragraph) => {
      const words = paragraph.trim().split(/\s+/).filter(Boolean);
      if (!words.length) {
        if (lines.length && lines[lines.length - 1] !== "") lines.push("");
        return;
      }

      let currentLine = "";
      words.forEach((word) => {
        const pieces = measuredWidth(word, rule.font, false) > rule.maxWidthPx
          ? splitBackToken(word, rule)
          : [word];

        pieces.forEach((piece) => {
          const candidate = currentLine ? `${currentLine} ${piece}` : piece;
          if (currentLine && measuredWidth(candidate, rule.font, false) > rule.maxWidthPx) {
            lines.push(currentLine);
            currentLine = piece;
          } else {
            currentLine = candidate;
          }
        });
      });

      if (currentLine) lines.push(currentLine);
    });

    while (lines.length && !lines[lines.length - 1]) lines.pop();
    return {
      lines: lines.slice(0, rule.maxLines),
      overflow: lines.length > rule.maxLines,
      totalLines: lines.length,
    };
  }

  function parseEditions(root) {
    const node = root.querySelector("[data-fp-editions]");
    if (!node) return [];

    try {
      const value = JSON.parse(node.textContent);
      return Array.isArray(value) ? value : [];
    } catch (error) {
      console.error("Flessenpost: variantdata kon niet worden gelezen.", error);
      return [];
    }
  }

  function initConfigurator(root) {
    if (!root || root.dataset.fpReady === "true") return;
    root.dataset.fpReady = "true";

    const form = root.querySelector("[data-fp-form]");
    if (!form) return;

    const editions = parseEditions(root);
    if (!editions.length) return;

    const inputs = Array.from(root.querySelectorAll("[data-fp-field]"));
    const frontInputs = inputs.filter((input) => input.dataset.fpField === "front");
    const backInputs = inputs.filter((input) => input.dataset.fpField === "back");
    const backInput = backInputs[0];
    const backLineInputs = Array.from(root.querySelectorAll("[data-fp-back-line-input]"));
    const senderInput = inputs.find((input) => input.dataset.fpField === "sender");
    const sideButtons = Array.from(root.querySelectorAll("[data-fp-side]"));
    const variantButtons = Array.from(root.querySelectorAll("[data-fp-variant]"));
    const galleryButtons = Array.from(root.querySelectorAll("[data-fp-gallery-thumb]"));
    const labelCanvas = root.querySelector("[data-fp-label-canvas]");
    const labelArt = root.querySelector("[data-fp-label-art]");
    const frontLayer = root.querySelector("[data-fp-front-layer]");
    const backLayer = root.querySelector("[data-fp-back-layer]");
    const variantInput = root.querySelector("[data-fp-variant-input]");
    const editionCodeInput = root.querySelector("[data-fp-edition-code]");
    const templateInput = root.querySelector("[data-fp-template-input]");
    const configInput = root.querySelector("[data-fp-config-input]");
    const productionInputs = Array.from(root.querySelectorAll("[data-fp-production-field]"));
    const confirmation = root.querySelector("[data-fp-confirm]");
    const upsell = root.querySelector("[data-fp-upsell]");
    const upsellCheckbox = root.querySelector("[data-fp-upsell-checkbox]");
    const upsellProperty = root.querySelector("[data-fp-upsell-property]");
    const priceOutput = root.querySelector("[data-fp-price]");
    const comparePriceOutput = root.querySelector("[data-fp-compare-price]");
    const priceNote = root.querySelector("[data-fp-price-note]");
    const submit = root.querySelector("[data-fp-submit]");
    const submitLabel = root.querySelector("[data-fp-submit-label]");
    const errorBox = root.querySelector("[data-fp-error]");
    let productImage = root.querySelector("[data-fp-product-image]");
    const productImagePlaceholder = root.querySelector("[data-fp-product-image-placeholder]");
    const defaultSubmitLabel = submitLabel ? submitLabel.textContent : "Voeg mijn fles toe";
    let currentSide = "front";
    let currentEdition = editions.find((edition) => edition.selected) || editions.find((edition) => edition.available) || editions[0];

    function valuesFor(kind) {
      return inputs
        .filter((input) => input.dataset.fpField === kind)
        .sort((a, b) => Number(a.dataset.fpIndex || 0) - Number(b.dataset.fpIndex || 0))
        .map((input) => input.value);
    }

    function setOutput(key, value, sample) {
      const output = root.querySelector(`[data-fp-output="${key}"]`);
      if (!output) return;
      output.textContent = value || "\u00a0";
      output.classList.toggle("is-sample", Boolean(sample));
    }

    function paintCustomerText() {
      const front = valuesFor("front");
      const backText = backInput ? backInput.value : "";
      const backLayout = wrapBackText(backText);
      const sender = senderInput ? senderInput.value : "";
      const hasFront = front.some((line) => line.trim());
      const hasBack = Boolean(backText.trim());

      front.forEach((line, index) => {
        setOutput(`front-${index}`, hasFront ? line : SAMPLE.front[index], !hasFront);
      });
      for (let index = 0; index < TEMPLATE.rules.back.maxLines; index += 1) {
        const line = hasBack ? backLayout.lines[index] || "" : SAMPLE.back[index];
        setOutput(`back-${index}`, line, !hasBack);
      }
      backLineInputs.forEach((input, index) => {
        input.value = hasBack ? backLayout.lines[index] || "" : "";
      });
      setOutput("sender", sender || SAMPLE.sender, !sender);

      if (configInput) {
        configInput.value = JSON.stringify({
          version: 3,
          template: currentEdition.template || TEMPLATE.id,
          edition: currentEdition.code,
          variantId: asText(currentEdition.id),
        });
      }
    }

    function setLabelFact(key, value) {
      root.querySelectorAll(`[data-fp-fact="${key}"]`).forEach((node) => {
        node.textContent = asText(value);
      });
    }

    function setProductionField(key, value) {
      productionInputs
        .filter((input) => input.dataset.fpProductionField === key)
        .forEach((input) => {
          input.value = asText(value);
        });
    }

    function setSide(side) {
      currentSide = side === "back" ? "back" : "front";
      const isFront = currentSide === "front";

      if (labelArt) {
        labelArt.src = isFront ? labelArt.dataset.frontSrc : labelArt.dataset.backSrc;
        labelArt.alt = isFront
          ? "Live drukproef van het voorlabel"
          : "Live drukproef van het achterlabel";
      }
      if (labelCanvas) {
        const width = Number(isFront ? labelCanvas.dataset.frontWidth : labelCanvas.dataset.backWidth);
        const height = Number(isFront ? labelCanvas.dataset.frontHeight : labelCanvas.dataset.backHeight);
        if (width > 0 && height > 0) {
          labelCanvas.style.setProperty("--fp-label-ratio", `${width} / ${height}`);
          if (labelArt) {
            labelArt.width = width;
            labelArt.height = height;
          }
        }
      }
      if (frontLayer) frontLayer.hidden = !isFront;
      if (backLayer) backLayer.hidden = isFront;

      sideButtons.forEach((button) => {
        const active = button.dataset.fpSide === currentSide;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      });
    }

    function setFactCard(key, value, selector) {
      const card = root.querySelector(`[data-fp-fact-card="${key}"]`);
      const output = root.querySelector(selector);
      const text = asText(value).trim();
      if (output) output.textContent = text;
      if (card) card.hidden = !text;
    }

    function formattedAbv(value) {
      const text = asText(value).trim();
      if (!text || text.includes("%")) return text;
      return `${text}%`;
    }

    function ensureProductImage() {
      if (!productImage && productImagePlaceholder) {
        productImage = document.createElement("img");
        productImage.dataset.fpProductImage = "";
        productImage.loading = "eager";
        productImagePlaceholder.replaceWith(productImage);
      }
      return productImage;
    }

    function setGallerySelection(selectedButton) {
      galleryButtons.forEach((button) => {
        const active = button === selectedButton;
        button.classList.toggle("is-selected", active);
        button.setAttribute("aria-current", String(active));
      });
    }

    function selectGalleryImage(button) {
      if (!button) return;
      const image = ensureProductImage();
      const src = button.dataset.fpImageSrc;
      if (!image || !src) return;

      image.src = src;
      image.alt = button.dataset.fpImageAlt || "Flessenpost productfoto";
      const width = Number(button.dataset.fpImageWidth);
      const height = Number(button.dataset.fpImageHeight);
      if (width > 0) image.width = width;
      if (height > 0) image.height = height;
      setGallerySelection(button);
    }

    function updateProductImage(edition) {
      if (!edition.image) return;
      const matchingButton = galleryButtons.find(
        (button) => String(button.dataset.fpMediaId) === String(edition.imageId),
      );
      if (matchingButton) {
        selectGalleryImage(matchingButton);
        return;
      }

      const image = ensureProductImage();
      if (image && image.src !== edition.image) {
        image.src = edition.image;
        image.alt = `Flessenpost ${edition.title}`;
      }
      setGallerySelection(null);
    }

    function updateUpsellState() {
      const selected = Boolean(upsellCheckbox && upsellCheckbox.checked);
      if (upsellProperty) upsellProperty.value = selected ? "Ja" : "Nee";
      if (upsell) upsell.classList.toggle("is-selected", selected);

      if (priceOutput) {
        priceOutput.textContent = selected && currentEdition.boxedPrice
          ? currentEdition.boxedPrice
          : currentEdition.price;
      }
      if (comparePriceOutput) {
        comparePriceOutput.textContent = selected ? "" : currentEdition.comparePrice || "";
        comparePriceOutput.hidden = selected || !currentEdition.comparePrice;
      }
      if (priceNote) {
        priceNote.textContent = selected
          ? "Inclusief etiketten en luxe houten kist."
          : priceNote.dataset.defaultNote || "";
      }
    }

    function localeRoot() {
      const configuredRoot = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : "/";
      const rootPath = asText(configuredRoot || "/");
      return rootPath.endsWith("/") ? rootPath : `${rootPath}/`;
    }

    function propertiesFromForm() {
      const properties = {};
      const formData = new FormData(form);
      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (!match) return;
        const textValue = asText(value);
        if (textValue) properties[match[1]] = textValue;
      });
      return properties;
    }

    function selectEdition(edition, updateUrl) {
      if (!edition) return;
      currentEdition = edition;

      root.style.setProperty("--fp-accent", edition.accent || "var(--fp-red)");
      if (variantInput) variantInput.value = edition.id;
      if (editionCodeInput) editionCodeInput.value = edition.code || "original";
      if (templateInput) templateInput.value = edition.template || TEMPLATE.id;

      variantButtons.forEach((button) => {
        const active = String(button.dataset.fpVariant) === String(edition.id);
        button.classList.toggle("is-selected", active);
        button.setAttribute("aria-pressed", String(active));
      });

      root.querySelectorAll("[data-fp-edition-short], [data-fp-order-title], [data-fp-locked-title]").forEach((node) => {
        node.textContent = edition.title;
      });
      root.querySelectorAll("[data-fp-locked-profile], [data-fp-profile]").forEach((node) => {
        node.textContent = edition.profile || "—";
      });

      updateUpsellState();

      const abv = formattedAbv(edition.abv);
      setProductionField("tasteProfile", edition.profile);
      setProductionField("legalCategory", edition.legalCategory);
      setProductionField("ageStatement", edition.ageStatement);
      setProductionField("abv", abv);
      setProductionField("origin", edition.origin);
      setProductionField("cask", edition.cask);
      setProductionField("labelProfile", edition.labelProfile || edition.title);
      setProductionField("date", edition.date);
      setFactCard("legalCategory", edition.legalCategory, "[data-fp-legal-category]");
      setFactCard("ageStatement", edition.ageStatement, "[data-fp-age]");
      setFactCard("abv", abv, "[data-fp-abv]");
      setFactCard("origin", edition.origin, "[data-fp-origin]");
      setLabelFact("origin", MOCKUP_ORIGIN);
      setLabelFact("cask", edition.cask);
      setLabelFact("labelProfile", edition.labelProfile || edition.title);
      setLabelFact("date", bottledToday());
      updateProductImage(edition);
      paintCustomerText();
      validateAll(false);

      if (updateUrl && window.history && window.URL) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", edition.id);
        window.history.replaceState({}, "", url.toString());
      }

      root.dispatchEvent(new CustomEvent("flessenpost:edition-change", { detail: { edition } }));
    }

    function validateInput(input) {
      const kind = input.dataset.fpField;
      const rule = TEMPLATE.rules[kind];
      const value = input.value;
      let message = "";

      const valueForCharacterCheck = kind === "back" ? value.replace(/[\r\n]+/g, " ") : value;

      if (valueForCharacterCheck && !allowedCharacters.test(valueForCharacterCheck)) {
        message = "Gebruik alleen letters, cijfers en gangbare leestekens; emoji worden niet ondersteund.";
      } else if (rule && rule.maxChars && value.length > rule.maxChars) {
        message = `Gebruik maximaal ${rule.maxChars} tekens.`;
      } else if (kind === "back" && wrapBackText(value).overflow) {
        message = "Deze tekst loopt na opmaak over meer dan acht regels. Maak hem iets korter.";
      } else if (kind !== "back" && rule && measuredWidth(value, rule.font) > rule.maxWidthPx) {
        message = "Deze regel is te breed voor het vaste drukvlak. Maak de tekst iets korter.";
      }

      input.setCustomValidity(message);
      input.dataset.fpErrorMessage = message;
      const field = input.closest(".fp-field");
      if (field) {
        field.classList.toggle("has-error", Boolean(message));
        const counter = field.querySelector("[data-fp-count]");
        if (counter) counter.textContent = String(value.length);
      }
      return !message;
    }

    function validateAll(announce) {
      const textValid = inputs.map(validateInput).every(Boolean);
      const hasMessage = [...frontInputs, ...backInputs].some((input) => input.value.trim());
      const confirmed = Boolean(confirmation && confirmation.checked);
      const available = Boolean(currentEdition.available);
      let message = "";

      if (!textValid) {
        const invalid = inputs.find((input) => input.validationMessage);
        message = invalid ? invalid.validationMessage : "Controleer de gemarkeerde tekstregels.";
      } else if (!hasMessage && announce) {
        message = "Vul minimaal één regel op het voor- of achterlabel in.";
      } else if (!confirmed && announce) {
        message = "Bevestig dat je tekst en spelling hebt gecontroleerd.";
      } else if (!available) {
        message = "Deze editie is momenteel uitverkocht.";
      }

      if (frontInputs[0]) {
        frontInputs[0].setCustomValidity(!hasMessage && announce ? message : frontInputs[0].dataset.fpErrorMessage || "");
      }

      const canSubmit = textValid && hasMessage && confirmed && available;
      if (submit) submit.disabled = !canSubmit;
      if (submitLabel) submitLabel.textContent = available ? defaultSubmitLabel : "Tijdelijk uitverkocht";
      if (errorBox) {
        errorBox.textContent = message;
        errorBox.hidden = !message;
      }
      return canSubmit;
    }

    inputs.forEach((input) => {
      input.addEventListener("input", () => {
        input.setCustomValidity("");
        validateInput(input);
        paintCustomerText();
        validateAll(false);
      });
      input.addEventListener("focus", () => {
        setSide(input.dataset.fpField === "front" ? "front" : "back");
      });
    });

    if (confirmation) {
      confirmation.addEventListener("change", () => validateAll(false));
    }

    if (upsellCheckbox) {
      upsellCheckbox.addEventListener("change", updateUpsellState);
    }

    sideButtons.forEach((button) => {
      button.addEventListener("click", () => setSide(button.dataset.fpSide));
    });

    galleryButtons.forEach((button) => {
      button.addEventListener("click", () => selectGalleryImage(button));
    });

    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const edition = editions.find((item) => String(item.id) === String(button.dataset.fpVariant));
        if (edition && edition.available) selectEdition(edition, true);
      });
    });

    form.addEventListener("submit", async (event) => {
      paintCustomerText();
      if (!validateAll(true)) {
        event.preventDefault();
        const firstInvalid = inputs.find((input) => !input.checkValidity());
        if (firstInvalid) {
          firstInvalid.focus();
          firstInvalid.reportValidity();
        } else if (confirmation && !confirmation.checked) {
          confirmation.focus();
        }
        return;
      }

      if (!upsellCheckbox || !upsellCheckbox.checked) return;

      event.preventDefault();
      const whiskyVariantId = Number(variantInput && variantInput.value);
      const boxVariantId = Number(upsellCheckbox.dataset.fpUpsellVariant);
      if (!whiskyVariantId || !boxVariantId) {
        if (errorBox) {
          errorBox.textContent = "De luxe houten kist is nog niet correct gekoppeld. Probeer het opnieuw zonder kist.";
          errorBox.hidden = false;
        }
        return;
      }

      const bundleId = `fp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const whiskyProperties = propertiesFromForm();
      whiskyProperties._fp_bundle_id = bundleId;
      const items = [
        {
          id: whiskyVariantId,
          quantity: Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1),
          properties: whiskyProperties,
        },
        {
          id: boxVariantId,
          quantity: 1,
          properties: {
            _fp_addon: "Luxe houten kist",
            _fp_addon_for: currentEdition.title,
            _fp_bundle_id: bundleId,
          },
        },
      ];

      let cartError = "";
      if (submit) {
        submit.disabled = true;
        submit.setAttribute("aria-busy", "true");
      }
      if (submitLabel) submitLabel.textContent = "Toevoegen…";

      try {
        const response = await fetch(`${localeRoot()}cart/add.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items }),
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(payload.description || payload.message || "De producten konden niet worden toegevoegd.");
        }

        const addedEvent = new CustomEvent("flessenpost:cart-added", {
          bubbles: true,
          cancelable: true,
          detail: { payload, items },
        });
        if (root.dispatchEvent(addedEvent)) window.location.assign(`${localeRoot()}cart`);
      } catch (error) {
        cartError = error && error.message
          ? error.message
          : "De fles en houten kist konden niet samen worden toegevoegd. Probeer het nogmaals.";
      } finally {
        if (submit) submit.removeAttribute("aria-busy");
        if (submitLabel) submitLabel.textContent = defaultSubmitLabel;
        validateAll(false);
      }

      if (cartError && errorBox) {
        errorBox.textContent = cartError;
        errorBox.hidden = false;
      }
    });

    paintCustomerText();
    setSide(currentSide);
    selectEdition(currentEdition, false);
  }

  function initAll(scope) {
    if (!scope) return;
    const roots = scope.matches && scope.matches("[data-fp-configurator]")
      ? [scope]
      : Array.from(scope.querySelectorAll("[data-fp-configurator]"));
    roots.forEach(initConfigurator);
  }

  window.FlessenpostConfigurator = Object.freeze({ template: TEMPLATE, init: initAll });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
